import React from "react";
import DatePicker from "antd/es/date-picker";
import PropTypes from 'prop-types';
import { getGlobalViewDateFormat } from "../utils/commonUtils";

const AntDatePicker = ({ value, onChange, disabled, defaultValue, disabledFutureDate,maxDate,minDate,format=getGlobalViewDateFormat(),placeholder="Select date",allowClear=false }) => {
  const maxTodayDate = new Date(); // Set it to today's date or any other maximum date you want

  // Function to disable future dates if disabledFutureDate is true
  const disabledDate = (current) => {
    if (disabledFutureDate) {
      return current && current > maxTodayDate;
    } else {
      return false; // Allow all dates if disabledFutureDate is false
    }
  };

  return (
    <DatePicker
      // style={{ width: '220px' }}
      defaultValue={defaultValue ? defaultValue : null}
      placeholder={placeholder}
      className="input-control w-full"
      wrapperClassName="w-full"
      value={value}
      onChange={onChange}
      format={format}
      disabled={disabled ? disabled : false}
      disabledDate={disabledDate} // Pass the disabledDate function
      inputReadOnly={true} // Disable manual input and clear button
      maxDate={maxDate?maxDate:''}
      minDate={minDate?minDate:''}
      allowClear={allowClear}
    />
  );
};

// Define prop types for the AntDatePicker component
AntDatePicker.propTypes = {
  value: PropTypes.object, // Date object
  onChange: PropTypes.func.isRequired, // Function to handle date change
  disabled: PropTypes.bool,
  defaultValue: PropTypes.object, // Date object
  disabledFutureDate: PropTypes.bool,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  placeholder:PropTypes.string,
  allowClea:PropTypes.bool,
};

export default AntDatePicker;
